/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Spinner from '../../../SharedModules/Spinner/SpinnerNew';
import TextField from '@material-ui/core/TextField';
import CustomSeparator from '../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import _ from 'lodash';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { labelerTableHead } from './AssignDisputeTableHead';
import TableGrid from '../../../SharedModules/Table/TableGridWithFeatures';
import SVGComponent from '../../../SharedModules/SVGComponents/SVGComponents';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../SharedModules/AgGridUtilities/suppressNavigation';
import axios from 'axios';
import * as serviceEndPoint from '../../../SharedModules/services/service';
import ErrorMessages from '../../../SharedModules/Errors/ErrorMessages';
import { getAssignDisputeDetail } from '../AssignDisputesSearch/store/action';
import {
  assignAllToDefaultUpdate,
  emailDisputeLetter,
  getFromMailId,
  printDisputeLetter,
  updateToMailId,
} from './store/actions';
import * as Constants from '../../../SharedModules/AppConstants';
import ViewHistoryComponent from '../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import DisplaySuccessMessages from '../../../SharedModules/Errors/SuccessMessage';
import { tabHighLigther } from '../../../SharedModules/utilities/utilities';
import * as constantMessageData from '../../../SharedModules/Errors/constantMessageData';
import {
  convertPDFURLFromAPI,
  emailValidation,
} from '../../../SharedModules/CommonUtilities/commonUtilities';
import { safeWindowOpen } from '../../../SharedModules/CommonUtilities/safeWindowOpen';
import CommonModal from '../../../SharedModules/Dialog/CommonModal';

const AssignDisputesDetails = (props) => {
  const dispatch = useDispatch();
  const [fullScreenView, setFullScreenView] = useState(false);
  const [disputeTableData, setDisputeTableData] = useState([]);
  const [selectedDispute, setSelectedDispute] = useState(null);
  const [spinnerLoader, setSpinnerLoader] = useState(false);
  const [errorMessage, setErrorMessages] = useState([]);
  const [successMessage, setSuccessMessages] = useState([]);
  const [keyValue, setKeyValue] = useState([]);
  const [update, setUpdate] = useState(false);
  const [rebateProgram, setRebateProgram] = useState({});
  const [selected, setSelected] = useState();
  const [programList, setProgramList] = useState();
  const [openDlg, setOpenDlg] = useState(false);
  // const [fromEmailData, setFromEmailData] = useState({});
  const [toMailList, setToMailList] = useState([]);
  const [tempData, setTempData] = React.useState();
  const [showViewHistory, setShowViewHistory] = useState(false);

  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );

  const clearMessages = () => {
    
      tabHighLigther('/assignDisputesDetails', false);
  };

  const handleViewHistory = (gridApi) => {
    //setSpinnerLoader(true);
    setErrorMessages([]);
    setSuccessMessages([]);
    const selectedRow = gridApi.getSelectedRows()?.[0]?.dispSeqNum;
    setShowViewHistory(true);
    if (selectedRow !== undefined) {
      setKeyValue({ DISP_SEQ_NUM: selectedRow });
    }
  };
  const data = useSelector(
    (state) => state?.sharedState?.AssignDisputesDetailReducer?.disputeDetails
  );
  React.useEffect(() => {
    if (data) {
      const program = data?.programList.find(
        (obj) => obj.id === data.selected.rebateProgramCD
      );
      setRebateProgram(program);
      if (program.id !== 'All') {
        const list = data?.data?.map((obj) => {
          obj['programDisplay'] = program.name;
          obj['assigned'] = parseInt(obj.assigned);
          obj['unassigned'] = parseInt(obj.unassigned);
          obj['total'] = parseInt(obj.assigned) + parseInt(obj.unassigned);
          return obj;
        });
        setDisputeTableData(list);
      } else {
        const programs = {};
        data.programList.forEach((obj) => (programs[obj.id] = obj.name));
        const list = data?.data.map((obj) => {
          obj['programDisplay'] = programs[obj.rebateProgramCd];
          obj['assigned'] = parseInt(obj.assigned);
          obj['unassigned'] = parseInt(obj.unassigned);
          obj['total'] = parseInt(obj.assigned) + parseInt(obj.unassigned);
          return obj;
        });
        setDisputeTableData(list);
      }
      setSelected(data.selected);
      setProgramList(data.programList);
      setSpinnerLoader(false);
      if (update) {
        setSuccessMessages([Constants.ASSIGN_TO_ALL_DEFAULT]);
        clearMessages();
        setUpdate(false);
      } else {
        // dispatch(getFromMailId(logInUser));
      }
    }
  }, [data]);
  const assignDefault = useSelector(
    (state) => state?.sharedState?.AssignDisputesDetailReducer?.assignDefault
  );
  // const fromMailId = useSelector(
  //   (state) => state?.sharedState?.AssignDisputesDetailReducer?.fromMailId
  // );

  const printMediaLetter = async (value) => {
    let listOfPrints = [];
    value.mailIdsForRespectiveMfgIds.map((obj) => {
      let list = obj.invoiceNum.map((inv) => {
        return {
          mfgId: obj.mfgId,
          invoiceNumber: inv,
          contactSeqNum: obj.contactSeqNum,
        };
      });
      listOfPrints = [...listOfPrints, ...list];
    });
    let payload = {
      userId: logInUser,
      listOfPrintPreviewVO: listOfPrints,
      templateHeader: {
        templateId: value.templateHeader.templateId,
        templateVersion: value.templateHeader.templateVersion,
        rebateProgramCd: value.templateHeader.rebateProgramCd,
        templateTypeCd: value.templateHeader.templateTypeCd,
        contactTypeCd: value.templateHeader.contactTypeCd,
        recipientTypeCd: value.templateHeader.recipientTypeCd,
        mediaCd: value.templateHeader.mediaCd,
      },
    };
    let res = await dispatch(printDisputeLetter(payload));
    if (res) {
      const url = convertPDFURLFromAPI(res);
      safeWindowOpen(url);
      setSuccessMessages([Constants.ASSIGN_TO_ALL_DEFAULT]);
      clearMessages();
    } else {
      setErrorMessages([Constants.ERR_PROCESSING_REQ]);
      tabHighLigther('/assignDisputesDetails', true);
    }
  };

  const emailMediaLetter = async (value) => {
    let listOfPrints = [];
    value.mailIdsForRespectiveMfgIds.map((obj) => {
      let list = obj.invoiceNum.map((inv) => {
        return {
          mfgId: obj.mfgId,
          invoiceNumber: inv,
          contactSeqNum: obj.contactSeqNum,
          emailSubject: 'DISPUTE',
          emailAddr: obj.email
            ? obj.email
            : toMailList.find((val) => val.mfgId === obj.mfgId)?.email,
        };
      });
      listOfPrints = [...listOfPrints, ...list];
    });
    let payload = {
      userId: logInUser,
      listOfPrintPreviewVO: listOfPrints,
      specialistEmailAddr: value.specialistEmailAddr,
      templateHeader: {
        templateId: value.templateHeader.templateId,
        templateVersion: value.templateHeader.templateVersion,
        rebateProgramCd: value.templateHeader.rebateProgramCd,
        templateTypeCd: value.templateHeader.templateTypeCd,
        contactTypeCd: value.templateHeader.contactTypeCd,
        recipientTypeCd: value.templateHeader.recipientTypeCd,
        mediaCd: value.templateHeader.mediaCd,
      },
    };
    let res = await dispatch(emailDisputeLetter(payload));
    if (res.status === '001' && res.message === 'SUCESS') {
      setSuccessMessages([Constants.ASSIGN_TO_ALL_DEFAULT]);
      clearMessages();
      setPrint(false);
    } else if (print) {
      printMediaLetter(value);
      setPrint(false);
    }
  };
  const [print, setPrint] = React.useState();
  React.useEffect(() => {
    if (assignDefault) {
      setSpinnerLoader(false);
      const { status, message } = assignDefault;
      if (status === '003') {
        setErrorMessages([message]);
        setSpinnerLoader(false);
        // clearMessages();
        tabHighLigther('/assignDisputesDetails', true);
      } else if (status === '001' && message === 'SUCESS') {
        const list = data?.data.map((obj) => {
          if (selectedDispute.specialist === obj.specialist) {
            obj.assigned = obj.total;
            obj.unassigned = 0;
          }
          return obj;
        });
        setDisputeTableData(JSON.parse(JSON.stringify(list)));
        if (gridapi) gridapi.refreshCells();
        let media = assignDefault?.data?.templateHeader?.mediaCd;
        if (media === 'PRINT') {
          printMediaLetter(assignDefault.data);
        } else if (media === 'EMAIL') {
          if (selectedDispute && !selectedDispute.specialist) {
            setErrorMessages([
              `Dispute specialist doesn't exist for the rebate program and email is not sent`,
            ]);
            tabHighLigther('/assignDisputesDetails', true);
          } else if (
            assignDefault?.data?.mailIdsForRespectiveMfgIds?.filter(
              (obj) => !obj.email
            )?.length
          ) {
            const list =
              assignDefault?.data?.mailIdsForRespectiveMfgIds?.filter(
                (obj) => !obj.email
              );
            setTempData(assignDefault.data);
            setToMailList(list ? list : []);
            setOpenDlg(true);
          } else emailMediaLetter(assignDefault.data);
        } else if (media === 'BOTH') {
          setPrint(true);
          if (
            assignDefault?.data?.mailIdsForRespectiveMfgIds?.filter(
              (obj) => !obj.email
            )?.length
          ) {
            const list =
              assignDefault?.data?.mailIdsForRespectiveMfgIds?.filter(
                (obj) => !obj.email
              );
            setTempData(assignDefault.data);
            setToMailList(list ? list : []);
            setOpenDlg(true);
          } else emailMediaLetter(assignDefault.data);
        }
        // dispatch(getAssignDisputeDetail(selected, programList));
        setUpdate(true);
      } else {
        setSpinnerLoader(false);
        setErrorMessages([Constants.ERR_PROCESSING_REQ]);
        tabHighLigther('/assignDisputesDetails', true);
        // clearMessages();
      }
    }
  }, [assignDefault]);
  const onSelectionChanged = useCallback((val) => {
    const selectedRows = val.api.getSelectedRows()[0];
    setSelectedDispute(selectedRows);
    setErrorMessages([]);
  }, []);

  const changeFullScreenView = () => {
    setFullScreenView(!fullScreenView);
    setErrorMessages([]);
    setSuccessMessages([]);
  };

  const onClickOk = () => {
    if (toMailList.filter((obj) => !obj.email || obj.error).length) {
      setToMailList(
        toMailList.map((obj) => {
          if (!obj.email) obj.error = constantMessageData.EMAIL_REQUIRED;
          return obj;
        })
      );
    } else {
      toMailList.map(async (obj) => {
        await dispatch(
          updateToMailId({
            contactSeqNum: obj.contactSeqNum,
            mailId: obj.email,
            userId: logInUser,
          })
        );
      });
      let payld = [];
      tempData.mailIdsForRespectiveMfgIds.map((obj) => {
        let updated = toMailList.find((o) => o.mfgId === obj.mfgId);
        if (updated) payld.push(updated);
        else payld.push(obj);
      });
      let newdata = { ...tempData, mailIdsForRespectiveMfgIds: payld };
      emailMediaLetter(newdata);
      setOpenDlg(false);
    }
  };
  const assignAllToDefault = () => {
    setErrorMessages([]);
    setSuccessMessages([]);
    if (selectedDispute) {
      if (!selectedDispute.unassigned || selectedDispute.unassigned === '0') {
        setErrorMessages(['No disputes found to assign.']);
        tabHighLigther('/assignDisputesDetails', true);
        return;
      }
      setSpinnerLoader(true);
      dispatch(
        assignAllToDefaultUpdate({
          rebateProgramCd: selectedDispute.rebateProgramCd,
          specialist: selectedDispute.specialist
            ? selectedDispute.specialist
            : '',
          assigned: JSON.stringify(selectedDispute.unassigned),
          lastUpdateUserId: logInUser,
          unassignedData: selectedDispute.unassignedData,
        })
      );
      // emailMediaLetter();
    }
  };

  const changeHandler = (val, fld, key) => {
    // if (fld === 'from') {
    //   let data = { mail: val, error: false };
    //   setFromEmailData(data);
    // } else {
    let data = toMailList.map((obj) => {
      if (obj.mfgId === key) {
        obj.email = val;
        obj.error = false;
      }
      return obj;
    });
    setToMailList([...data]);
    // }
  };

  const blurHandler = (val, fld, key) => {
    let err = emailValidation(val)
      ? false
      : val && val !== ''
      ? constantMessageData.EMAIL_INVALID
      : constantMessageData.EMAIL_REQUIRED;
    // if (fld === 'from') {
    //   setFromEmailData({
    //     mail: val,
    //     error: err,
    //   });
    // } else {
    let data = toMailList.map((obj) => {
      if (obj.mfgId === key) {
        obj.email = val;
        obj.error = err;
      }
      return obj;
    });
    setToMailList([...data]);
    // }
  };
  const [gridapi, setGridApi] = React.useState();
  const onGridReady = (params) => {
    params.api.forEachNode((node) =>
      node.rowIndex === 0 ? node.setSelected(true) : node.setSelected(false)
    );
    setGridApi(params.api);
  };

  return (
    <div className='tabs-container'>
      <Spinner load={spinnerLoader} />
      <CustomSeparator parent1={'Tasks'} parent2={'Assign Disputes Detail'} />
      {successMessage.length > 0 && (
        <DisplaySuccessMessages successMessages={successMessage} />
      )}
      {errorMessage.length > 0 && (
        <ErrorMessages errorMessages={errorMessage} />
      )}
      <div className='tab-body'>
        {!fullScreenView && (
          <div className='row'>
            <div className='col-12 col-sm-6 col-md-4'>
              <fieldset className='custom-fieldset' style={{ height: 'auto' }}>
                <legend className='same-font-family'>Rebate Program</legend>
                <div className='form-wrapper'>
                  <div className='mui-custom-form input-md field-md no-lbl'>
                    <TextField
                      id='batches-for-payee-select-box'
                      label='Rebate Program'
                      InputLabelProps={{ shrink: true }}
                      value={rebateProgram?.name}
                      disabled={true}
                    ></TextField>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        )}
        <div className='row'>
          <div className='col-12'>
            <TableGrid
              gridHeight={fullScreenView ? '100vh' : 350}
              rowData={disputeTableData}
              columnDefs={labelerTableHead}
              gridCall={onGridReady}
              fileName={'Assign Dispute Detail'}
              onSelectionChanged={onSelectionChanged}
              navigateToNextCell={navigateToNextCell}
              //tabToNextCell={tabToNextCell}
              enterMovesDown={true}
              suppressCellFocus={true}
              onCellFocused={onCellFocused}
              exportFile={true}
              handleViewHistory={handleViewHistory}
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={changeFullScreenView}
            />
          </div>
        </div>
        {!fullScreenView && (
          <div className='row'>
            <div className='btn-wrapper col-12'>
              <Button
                className='btn btn-success btn-search float-right'
                onClick={assignAllToDefault}
              >
                Assign All to Default
              </Button>
            </div>
          </div>
        )}
      </div>
      <CommonModal
        data-testid='dispute-mail-popup'
        open={openDlg}
        viewAction
        viewHeader
        className='dialog-420'
        okTitle='Ok'
        onOk={onClickOk}
        onClose={() => setOpenDlg(false)}
        closeTitle='Cancel'
        modalTitle='Request Email Address'
        childrenComponent={
          <div className='mb-2'>
            <p className='float-right'>
              <OverlayTrigger
                placement='bottom'
                overlay={<Tooltip id='print-tooltip'>Print</Tooltip>}
              >
                <div className='top-bell-icon th-icon'>
                  {print && (
                    <div onClick={() => printMediaLetter(tempData)}>
                      <SVGComponent iconName='Icon-printer' />
                    </div>
                  )}
                </div>
              </OverlayTrigger>
            </p>
            <p>{constantMessageData.ENTER_VALID_EMAIL_OR_CANCEL}</p>
            {!_.isEmpty(toMailList) &&
              _.map(toMailList, (l) => (
                <div className='input-md mandate-fields'>
                  <TextField
                    className='mb-3'
                    id={l.mfgId}
                    label={l.mfgName}
                    required
                    data-testid='frommail'
                    value={l?.email || ''}
                    inputProps={{ maxLength: 50, id: l.mfgId }}
                    onChange={(e) =>
                      changeHandler(e.target.value, 'to', l.mfgId)
                    }
                    onBlur={(e) => blurHandler(e.target.value, 'to', l.mfgId)}
                    InputLabelProps={{ shrink: true }}
                    helperText={l?.error}
                    error={l?.error}
                  />
                </div>
              ))}
            {/* {!fromMailId && (
              <div className="input-md mandate-fields">
                <TextField
                  className="mb-3"
                  id="descsrt"
                  label={localStorage.getItem('logInUser')}
                  required
                  data-testid="frommail"
                  value={fromEmailData?.mail || ''}
                  inputProps={{ maxLength: 30, id: 'descsrt' }}
                  onChange={(e) => changeHandler(e.target.value, 'from')}
                  onBlur={(e) => blurHandler(e.target.value, 'from')}
                  InputLabelProps={{ shrink: true }}
                  helperText={fromEmailData?.error}
                  error={fromEmailData?.error}
                />
              </div>
            )} */}
          </div>
        }
      />
      {showViewHistory && (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName='DISPUTE'
          keyValue={keyValue}
        />
      )}
    </div>
  );
};

export default AssignDisputesDetails;
